module.exports = __webpack_public_path__ + "static/media/pi.dfa7dcb0.svg";